﻿
(function ($, document, window) {

    var createCookie = function (name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }
        else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    };

    var getCookie = function (name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
    };

    $(document).ready(function (e) {
        var cookie = getCookie();
        if (cookie == null) {
            window.EnableEssentialCookies = true;
            window.EnableFunctionalCookies = false;
            window.EnablePerformanceCookies = false;
        } else {
            var model = JSON.parse(cookie);
            window.EnableEssentialCookies = true;
            window.EnableFunctionalCookies = model.functional;
            window.EnablePerformanceCookies = model.performance;
        }

        if ($('[data-accept-cookie]').length > 0) {
            function gtag() { dataLayer.push(arguments); }
            $(document).on('click', '[data-accept-cookie]', function (e) {
                e.preventDefault();
                var model = {
                    essential: true,
                    functional: true,
                    performance: true
                }

                gtag('consent', 'update', {
                    'ad_user_data': 'granted',
                    'ad_personalization': 'granted',
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted'
                });
                createCookie('cookie-acceptance', JSON.stringify(model), 365);
                var $banner = $('[data-cookie-banner]');
                $('[data-cookie-banner]').animate(
                    {
                        bottom: "-=" + $banner.outerHeight()
                    },
                    400,
                    function () {
                      $('[data-cookie-banner]').remove();
                      var event = new CustomEvent('cookieBannerClosed');
                      document.dispatchEvent(event);
                    }
                );
                
            });
        }
    });


})($, document, window);